import { render, staticRenderFns } from "./CustomSnackbar.vue?vue&type=template&id=47c70f60&scoped=true&lang=pug&"
import script from "./CustomSnackbar.vue?vue&type=script&lang=js&"
export * from "./CustomSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./CustomSnackbar.vue?vue&type=style&index=0&id=47c70f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c70f60",
  null
  
)

export default component.exports